export const ADD_FLASH_MESSAGE = "ADD_FLASH_MESSAGE";
export const DELETE_FLASH_MESSAGE = "DELETE_FLASH_MESSAGE";
export const CHANGE_POLL_PAGE = "CHANGE_POLL_PAGE";
export const NEXT_POLL_PAGE = "NEXT_POLL_PAGE";
export const PREVIOUS_POLL_PAGE = "PREVIOUS_POLL_PAGE";
export const CANCEL_CONFIRM_DIALOG = "CANCEL_CONFIRM_DIALOG";
export const SEND_FORM = "SEND_FORM";
export const REAL_SEND_POLL = "REAL_SEND_POLL";
export const POLL_PROPERLY_SAVED = "POLL_PROPERLY_SAVED";
export const POLL_NOT_PROPERLY_SAVED = "POLL_NOT_PROPERLY_SAVED";
export const CLOSE_SAVE_ERROR_DIALOG = "CLOSE_SAVE_ERROR_DIALOG";



// WEBPACK FOOTER //
// ./src/actions/types.js